<template>
  <div dir="rtl">
    <div
      v-show="loading"
      style="width: 100%;height: 100%;position: fixed;top: 0px;left: 0px;z-index: 999;background: rgba(0,0,0,.4);"
    >
      <img
        src="../../assets/images/spinner.gif"
        width="100"
        style="position: absolute;top: 50%;left: 50%;width:100px"
      />
    </div>
    <v-container>
      <v-layout wrap="">
        <!-- <v-flex xs12 sm6 md2>
           <v-text-field @keyup.enter="search_client_by_code"  v-model="searchClientCode" label="كودالعميل"  ></v-text-field>
            </v-flex> 
             <v-flex xs12 sm6 md4>
                    <v-select
                    v-model="select_client"
                    :items="clients"
                    item-text="name"
                    item-value="id"
                    label="أختر العميل"
                    persistent-hint
                    return-object
                    single-line
                    @change="get_all_info"
                ></v-select>
                  </v-flex> -->
        <v-flex xs12 sm6 md4>
          <v-select
            v-model="select_bank"
            :items="banks"
            item-text="name"
            item-value="id"
            label=" أختر البنك "
            persistent-hint
            return-object
            single-line
            @change="get_bank"
          ></v-select>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-text-field
            v-model="money"
            type="number"
            label="المبلغ"
          ></v-text-field>
        </v-flex>
        <v-flex xs12 sm10 md10>
          <v-textarea v-model="comment" rows="2" label="ملاحظات"></v-textarea>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-dialog
            ref="dialog2"
            v-model="modal2"
            :return-value.sync="date2"
            persistent
            lazy
            full-width
            width="290px"
          >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date2"
                label=" التاريخ اليدوي"
                readonly
                outline
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker v-model="date2" scrollable>
              <v-spacer></v-spacer>
              <v-btn flat color="primary" @click="modal2 = false">Cancel</v-btn>
              <v-btn flat color="primary" @click="$refs.dialog2.save(date2)"
                >OK</v-btn
              >
            </v-date-picker>
          </v-dialog>
        </v-flex>
        <v-flex xs12 sm6 md2>
          <v-btn @click="add_bank_withdrew">سحب</v-btn>
        </v-flex>
      </v-layout>

      <v-layout v-if="theBank != {}">
        <v-flex xs12 sm3 md3>الاسم</v-flex>
        <v-flex xs12 sm3 md3>الرصيد</v-flex>
      </v-layout>
      <v-layout v-if="theBank != {}">
        <v-flex xs12 sm3 md3>{{ theBank.name }}</v-flex>
        <v-flex xs12 sm3 md3>{{ theBank.rasid }}</v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
import {
  clients,
  madionia_client,
  fatworas_client_no_sadad,
  banks,
  bank,
  bank_fatworas,
  add_bank_withdrew,
  log_me
} from "../config/apiRoute.js";
export default {
  data: () => ({
    user: [],
    permissions: [],
    add_dialog: false,
    edit_dialog: false,
    headers: [
      {
        text: " الاسم",
        align: "right",
        value: "name",
        sortable: false
      },
      { text: " الموظف", value: "address", sortable: false, align: "right" },
      { text: " الرصيد", value: "rasid", sortable: false, align: "right" },
      { text: " النوع", value: "rasid", sortable: false, align: "right" }
    ],
    select_client: { id: "" },
    select_bank: { id: "" },
    search: "",
    comment: "",
    loading: true,
    menu2: false,
    dialog2: false,
    modal2: false,
    date2: new Date().toISOString().substr(0, 10),
    bank_fatworas: [],
    clients: [],
    fatworas: [],
    banks: [],
    all_client_fatworas: [],
    all_client_sadads: [],
    theBank: {},
    money: "",
    searchClientCode: "",
    madionia_sabqa: "",
    madionia_sabqa_of_madionia: "",

    bank_fatwora_table: {
      code: "",
      emp_name: "",
      rasid_before: "",
      money: "",
      rasid_after: "",
      type: "",
      notes: "",
      bank_id: "",
      created_at: ""
    },

    bank_update: {
      id: "",
      rasid: ""
    }
  }),

  computed: {
    mycode() {
      if (this.bank_fatworas.length > 0) {
        return (this.code =
          parseInt(this.bank_fatworas[this.bank_fatworas.length - 1].code) + 1);
      } else {
        return (this.code = 1000);
      }
    }
  },

  watch: {
    //    dialog (val) {
    //   val || this.close()
    // }
  },

  created() {
    this.user = JSON.parse(localStorage.getItem("user"));
    this.permissions = JSON.parse(localStorage.getItem("permission"));
    this.initialize();
  },

  methods: {
    initialize() {
      clients().then(response => {
        this.clients = response.data;
        this.loading = false;
      });
      banks().then(response => {
        this.banks = response.data;
      });

      bank_fatworas().then(response => {
        this.bank_fatworas = response.data;
      });
    },

    get_all_info() {
      this.searchClientCode = this.select_client.code;
      this.fatworas = [];
      this.madionia_sabqa = "";
      this.loading = true;
      fatworas_client_no_sadad(this.select_client.id).then(response => {
        this.fatworas = response.data;
        this.loading = false;
      });
      madionia_client(this.select_client.id).then(response => {
        this.madionia_sabqa =
          (response.data.madionia != 0
            ? parseFloat(response.data.madionia)
            : 0) +
          (response.data.client.rasid_efttahi != ""
            ? response.data.client.rasid_efttahi != ""
              ? parseFloat(response.data.client.rasid_efttahi)
              : 0
            : 0);
        this.madionia_sabqa_of_madionia =
          response.data.madionia != 0 ? parseFloat(response.data.madionia) : 0;
      });
    },

    get_bank() {
      bank(this.select_bank.id).then(response => {
        this.theBank = response.data;
      });
    },

    close() {
      this.add_dialog = false;
      this.edit_dialog = false;
      //   setTimeout(() => {
      //     this.editedItem = Object.assign({}, this.defaultItem)
      //     this.editedIndex = -1
      //   }, 300)
    },

    add_bank_withdrew() {
      let myUser = JSON.parse(localStorage.getItem("user"));

      this.bank_fatwora_table.code = this.mycode;
      this.bank_fatwora_table.emp_name = myUser.name;
      this.bank_fatwora_table.rasid_before = this.select_bank.rasid;
      this.bank_fatwora_table.money = this.money;
      this.bank_fatwora_table.rasid_after = parseFloat(this.money);
      this.bank_fatwora_table.type = "out";
      this.bank_fatwora_table.notes = this.comment;
      this.bank_fatwora_table.bank_id = this.select_bank.id;
      this.bank_fatwora_table.created_at = this.date2;

      let bank_fatwora_ = JSON.stringify(this.bank_fatwora_table);

      this.bank_update.id = this.select_bank.id;
      this.bank_update.rasid = this.money;

      let bank_ = JSON.stringify(this.bank_update);

      this.do_deposit(bank_fatwora_, bank_);
    },
    do_deposit(bank_fatwora_, bank_) {
      this.loading = true;
      var frmData = new FormData();
      frmData.append("bank", bank_);
      frmData.append("bank_fatwora", bank_fatwora_);
      add_bank_withdrew(frmData).then(response => {
        this.loading = false;
        this.$router.go(0);
        var frmData3 = new FormData();
        frmData3.append("title", "عمل سحب بنك");
        frmData3.append(
          "body",
          "تم سحب لبنك  " +
            this.select_bank.name +
            " وكود " +
            this.bank_fatwora_table.code +
            " مبلغ " +
            this.money +
            " بواسطة " +
            this.user.name
        );
        frmData3.append("type", "bank_withdrew");
        frmData3.append("user_id", this.user.id);
        log_me(frmData3).then(response => {
          if (response.data == true) {
            let mytitle = "عمل سحب بنك";
            let mybody =
              "تم سحب لبنك  " +
              this.select_bank.name +
              " وكود " +
              this.bank_fatwora_table.code +
              " مبلغ " +
              this.money +
              " بواسطة " +
              this.user.name;
            this.$toastr.warning(mybody, mytitle, {
              closeButton: true,
              progressBar: true,
              positionClass: "toast-bottom-left",
              preventDuplicates: false,
              timeOut: "25000"
            });
            this.$router.go(0);
          }
        });
      });
    },
    push_client_sadad(sadad) {
      this.all_client_sadads.push(sadad);
    }
  }
};
</script>

<style scope>
.v-datatable__actions__range-controls {
  display: none;
}
.v-dialog.v-dialog--active {
  direction: rtl;
}
.v-label.v-label--active {
  right: 0px !important;
}
.v-label.theme--light {
  right: 0px !important;
}
</style>
